import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-content">
          <div className="footer-logo">
            <Link to="/">
              <span className="footer-logo-text">Resume Tailor</span>
            </Link>
            <p className="footer-tagline">
              Customize your resume for every job opportunity
            </p>
          </div>

          <div className="footer-links">
            {/* Product */}
            <div className="footer-links-section">
              <h4 className="footer-links-title">Product</h4>
              <ul className="footer-links-list">
                <li className="footer-link-item">
                  <Link to="/tailor">Tailor Resume</Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/pricing">Pricing</Link>
                </li>
              </ul>
            </div>

            {/* Resources */}
            <div className="footer-links-section">
              <h4 className="footer-links-title">Resources</h4>
              <ul className="footer-links-list">
                <li className="footer-link-item">
                  <Link to="/about">About</Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/help">Help Center</Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/faq">FAQ</Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/contact">Contact</Link>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div className="footer-links-section">
              <h4 className="footer-links-title">Company</h4>
              <ul className="footer-links-list">
                <li className="footer-link-item">
                  <a href="https://opp-liy.vercel.app/" target="_blank" rel="noopener noreferrer">OppLiy</a>
                </li>
                <li className="footer-link-item">
                  <Link to="/">CVance</Link>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div className="footer-links-section">
              <h4 className="footer-links-title">Legal</h4>
              <ul className="footer-links-list">
                <li className="footer-link-item">
                  <Link to="/terms">Terms of Service</Link>
                </li>
                <li className="footer-link-item">
                  <Link to="/privacy">Privacy Policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            &copy; {currentYear} CVance. All rights reserved.
          </p>
          <div className="social-links">
            <a
              href="https://linkedin.com/in/venkatasaipunnam"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://instagram.com/cvance_oppliy"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
